import { showFailToast } from "vant";


/**
 * 应用异常
 * 应用异常统一通过vant toast抛异常
 */
export class AppException extends Error {
    constructor(message: string) {
        super(message);
        showFailToast(message);
    }
}